var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-content"},[_c('md-spinner',{attrs:{"md-indeterminate":""}}),_c('span',[_vm._v("Please wait...")])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }